import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';
import { AppModules } from '../../appContainer/types';

export const routes = {
  path: '/tasks',
  title: 'Tasks',
  appModule: AppModules.TASKS,
  children: [
    {
      path: { index: true },
      content: async (): PathRouteContent =>
        (await import('./TasksPage')).TasksPage,
    },
    {
      path: '/:taskId',
      content: async (): PathRouteContent =>
        (await import('./TasksPage')).TasksPage,
    },
  ],
} as const satisfies RouteNode;
